import React, { PropTypes } from 'react';
import { PromiseState } from 'react-refetch';
import { Item, Modal, PromiseStateContainer } from '../../components';
import { termDetailConnect } from '../../connect';

const TermModal = ({ term, letter, definition, subitems, termDetailFetch }) =>
  (term && letter && definition) || subitems
    ? <Modal title={term}>
        <Item term={term} letter={letter} definition={definition} subitems={subitems} />
      </Modal>
    : <PromiseStateContainer
        ps={PromiseState.race([termDetailFetch])}
        onFulFillment={termItem => (
          <Modal title={termItem.term}>
            <Item
              term={termItem.term}
              letter={termItem.letter}
              definition={termItem.definition}
              subitems={termItem.subitems}
            />
          </Modal>
        )}
      />;

TermModal.defaultProps = {
  term: null,
  letter: null,
  definition: null,
  subitems: null
};

TermModal.propTypes = {
  term: PropTypes.string,
  letter: PropTypes.string,
  definition: PropTypes.string,
  subitems: PropTypes.object,
  termDetailFetch: PropTypes.instanceOf(PromiseState).isRequired
};

export default termDetailConnect(TermModal);



// WEBPACK FOOTER //
// ./src/pages/identity-glossary/components/TermModal/TermModal.js